import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteBulkCallerAddresses = async (callerId: string, addressIds: number[]) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteBulkCallerAddresses($callerId: String!, $addressIds: [Float!]!) {
        deleteBulkCallerAddresses(callerId: $callerId, addressIds: $addressIds)
      }
    `),
    variables: {
      callerId,
      addressIds,
    },
  });

  return response.data?.deleteBulkCallerAddresses ?? false;
};
